import { CAST_AI } from '@cast/constants';

import { useConnectionProgress } from './useConnectionProgress';
import {
  EnablingStepLayout,
  ConnectionProgressRow,
  WhatHappensNextBullet,
  WhatHappensNextSection,
} from '../../../../_components/new-onboarding';

export const ConnectingStep = ({
  onClose,
  onBack,
}: {
  onClose: () => void;
  onBack: () => void;
}) => {
  const { clusterConnection, featureItems } = useConnectionProgress();

  return (
    <EnablingStepLayout
      onBack={onBack}
      onClose={onClose}
      testId="connecting-step"
      title="Connecting your cluster"
    >
      <WhatHappensNextSection>
        <WhatHappensNextBullet>
          Your cluster will be connected to {CAST_AI}
        </WhatHappensNextBullet>
        <ConnectionProgressRow item={clusterConnection} />
        <WhatHappensNextBullet>
          {CAST_AI} components will be deployed to your cluster
        </WhatHappensNextBullet>
        {featureItems.map((item) => (
          <ConnectionProgressRow key={item.key} item={item} />
        ))}
        <WhatHappensNextBullet>
          Data collection will begin within 5 minutes
        </WhatHappensNextBullet>
        <WhatHappensNextBullet>
          Product recommendations will appear in 15-30 minutes
        </WhatHappensNextBullet>
      </WhatHappensNextSection>
    </EnablingStepLayout>
  );
};
